import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { billingService, queryKeys } from '@/services';
import type { BillingStatementListParams } from '@/services/billing/billing-service';

export const useBillingStatements = (
  filters?: BillingStatementListParams,
  // `enabled: false` for callers whose filters are not known yet (the document
  // page derives them from another query) — without it the mount fires a wasted
  // unfiltered page-1 request before the real one.
  { enabled = true }: { enabled?: boolean } = {},
) => {
  const cacheKey = filters
    ? Object.fromEntries(
        Object.entries(filters)
          .filter(([, v]) => v !== undefined && v !== '')
          .map(([k, v]) => [k, String(v)]),
      )
    : undefined;

  return useQuery({
    queryKey: queryKeys.billing.statementList(cacheKey),
    queryFn: () => billingService.getStatements(filters),
    enabled,
    // LR-551 made the key vary with the filters, so every filter change would
    // otherwise drop to no-data and swap the whole table for a full-height
    // spinner. Keep the previous slice on screen while the new one loads.
    placeholderData: keepPreviousData,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
};
